import {
  CheckCircle,
  Eye,
  FileText,
  Mail,
  MessageSquare,
  Pencil,
  Phone,
} from 'lucide-react'

import { Button } from '@/shared/components/ui/button'
import { cn } from '@/shared/lib/utils'

export default function LeadActionButtons({
  onCall,
  onEmail,
  onMessage,
  onQuotation,
  hasQuotation = false,
  onView,
  onEdit,
  unreadCount = 0,
  onConfirmFollowUp,
  canConfirmFollowUp = false,
  followUpConfirmed = false,
}) {
  return (
    <div className="flex w-[264px] items-center justify-start gap-1">
      {/* Call */}
      <div className="flex h-8 w-8 shrink-0 items-center justify-center">
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 rounded-full"
          onClick={onCall}
          title="Call"
        >
          <Phone className="size-4" />
        </Button>
      </div>

      {/* Email */}
      <div className="flex h-8 w-8 shrink-0 items-center justify-center">
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 rounded-full"
          onClick={onEmail}
          title="Email"
        >
          <Mail className="size-4" />
        </Button>
      </div>

      {/* Message */}
      <div className="relative flex h-8 w-8 shrink-0 items-center justify-center">
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 rounded-full"
          onClick={onMessage}
          title="Message"
        >
          <MessageSquare className="size-4" />
        </Button>

        {unreadCount > 0 && (
          <span className="absolute -right-1 -top-1 flex size-4 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </div>

      {/* Quotation */}
      <div className="flex h-8 w-8 shrink-0 items-center justify-center">
        <Button
          variant="ghost"
          size="icon"
          className={cn(
            'h-8 w-8 rounded-full',
            hasQuotation &&
              'text-indigo-600 bg-indigo-50/80 hover:bg-indigo-100 hover:text-indigo-700',
          )}
          onClick={onQuotation}
          title={hasQuotation ? 'Edit Quotation' : 'Create Quotation'}
        >
          <FileText className="size-4" />
        </Button>
      </div>

      {/* Edit */}
      <div className="flex h-8 w-8 shrink-0 items-center justify-center">
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 rounded-full text-slate-700 hover:bg-slate-100 hover:text-slate-900"
          onClick={onEdit}
          title="Edit Lead"
        >
          <Pencil className="size-4" />
        </Button>
      </div>

      {/* View */}
      <div className="flex h-8 w-8 shrink-0 items-center justify-center">
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 rounded-full text-indigo-600 hover:bg-indigo-50 hover:text-indigo-700"
          onClick={onView}
          title="View Details"
        >
          <Eye className="size-4" />
        </Button>
      </div>

      {/* Follow-up confirmation
          Keep the slot reserved even when the button is hidden.
          This prevents the other action icons from moving. */}
      <div className="flex h-8 w-8 shrink-0 items-center justify-center">
        {canConfirmFollowUp && (
          <Button
            variant="ghost"
            size="icon"
            className={`h-8 w-8 rounded-full ${
              followUpConfirmed
                ? 'text-emerald-600 hover:bg-emerald-50 hover:text-emerald-700'
                : 'text-red-600 hover:bg-red-50 hover:text-red-700'
            }`}
            onClick={onConfirmFollowUp}
            title={
              followUpConfirmed ? 'Follow Up Completed' : 'Confirm Follow Up'
            }
          >
            <CheckCircle className="size-4" />
          </Button>
        )}
      </div>
    </div>
  )
}
